var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSupportContact = function SvgSupportContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.714,
    clipPath: "url(#supportContact_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.238 10.286h1.714a.857.857 0 0 1 .858.857v4.285a.857.857 0 0 1-.858.858H3.238a1.714 1.714 0 0 1-1.714-1.715V12a1.714 1.714 0 0 1 1.714-1.714M22.095 16.286h-1.714a.857.857 0 0 1-.857-.858v-4.285a.857.857 0 0 1 .857-.857h1.714A1.715 1.715 0 0 1 23.81 12v2.571a1.714 1.714 0 0 1-1.715 1.715"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.952 21a3.43 3.43 0 0 0 3.429-3.429v-1.285"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.81 18.857a2.143 2.143 0 1 1 0 4.286h-2.572a2.143 2.143 0 0 1 0-4.286zM4.952 10.286V8.57a7.714 7.714 0 0 1 15.429 0v1.715M10.095 6.857V9.43M15.238 6.857V9.43M10.095 12.857c0 2.28 5.143 2.28 5.143 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "supportContact_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.667 0h24v24h-24z"
  })))));
};
export default SvgSupportContact;